import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { translate } from 'react-i18next';
import { request } from './../../../../../config';
import lastOperationsIcon from './../../../img/last-operations-icon.png';
import operationFilter from './../../../../../helpers/operationFilter';
import transferFilter from './../../../../../helpers/transferFilter';
import { statusCodes } from '../../../../../helpers/statusCodes';

class Statements extends Component {
    state = {
        operations: []
    }
    getFormatedDate = (date) => {
        if (date) {
            let formatedDate = {
                day: (date.getDate() < 9) ? ('0' + date.getDate()) : date.getDate(),
                month: (date.getMonth() < 9) ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1),
                year: date.getFullYear().toString()
            }
            return formatedDate.day + '.' + formatedDate.month + '.' + formatedDate.year;
        }
        return null;
    }
    showStates = () => {
        let now = new Date();
        let threeDaysBefore = new Date();
        threeDaysBefore.setDate(now.getDate() - 90);
        let startDate = this.getFormatedDate(threeDaysBefore);
        let endDate = this.getFormatedDate(now);
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let operStateId;
        let customerType = localStorage.getItem('compId') === null ? 'Individual' : 'Juridical';

        switch (this.props.location.pathname) {
            case '/dashboard/transfer/transfers/all': operStateId = null; break;
            case '/dashboard/transfer/transfers/confirmed': operStateId = 4; break;
            case '/dashboard/transfer/transfers/waiting': operStateId = 3; break;
            case '/dashboard/transfer/transfers/first-authorization': operStateId = 1; break;
            case '/dashboard/transfer/transfers/second-authorization': operStateId = 2; break;
            case '/dashboard/transfer/transfers/refused': operStateId = 5; break;
            case '/dashboard/transfer/transfers/edit-pending': operStateId = 7; break;
        }
        let operationAdvancedSearchRequestBody = customerType === 'Juridical' ? {
            custId: localStorage.getItem('custId'),
            compId: localStorage.getItem('compId'),
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            operStateId: operStateId,
            dtIban: null,
            minAmt: null,
            maxAmt: null,
            startDate: startDate,
            endDate: endDate,
            operNameId: null
        } :
            {
                custId: localStorage.getItem('custId'),
                token: localStorage.getItem('token'),
                lang: localStorage.getItem('i18nextLng').toUpperCase(),
                operStateId: operStateId,
                dtIban: null,
                minAmt: null,
                maxAmt: null,
                startDate: startDate,
                endDate: endDate,
                operNameId: null
            }

        fetch(request("operation/operationAdvancedSearch", operationAdvancedSearchRequestBody))
            .then(res => res.text())
            .then((operationAdvancedSearchResponseJSON) => {
                const JSON = require('true-json-bigint');
                let operationAdvancedSearchResponse = JSON.parse(operationAdvancedSearchResponseJSON);
                if (operationAdvancedSearchResponse.status.statusCode !== 1 && operationAdvancedSearchResponse.status.statusCode !== 240) {
                    if (operationAdvancedSearchResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        operationAdvancedSearchResponse.status.statusCode === statusCodes.ACCESS_DENIED_OPERATION ?
                            this.props.alertState(
                                true,
                                'warning',
                                this.props.t('Information'),
                                this.props.t(operationAdvancedSearchResponse.status.statusCode),
                                null,
                                true
                            ) :
                            this.props.alertState(
                                true,
                                'error',
                                this.props.t('an error occurred'),
                                this.props.t(operationAdvancedSearchResponse.status.statusCode),
                            )
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    if (operationAdvancedSearchResponse.status.statusCode === 240) {
                        operationAdvancedSearchResponse.operationList = [];
                    }

                    for (let i = 0; i < operationAdvancedSearchResponse.operationList.length; i++) {
                        let amount, currency;
                        if (operationAdvancedSearchResponse.operationList[i].operNameId !== 4) {
                            amount = operationAdvancedSearchResponse.operationList[i].amount;
                            currency = operationAdvancedSearchResponse.operationList[i].currency;
                        }
                        else {
                            if (operationAdvancedSearchResponse.operationList[i].operTypeId === 5) {
                                amount = operationAdvancedSearchResponse.operationList[i].crAmt;
                                currency = operationAdvancedSearchResponse.operationList[i].crCcy;
                            }
                            else {
                                if (operationAdvancedSearchResponse.operationList[i].operTypeId === 6) {
                                    amount = operationAdvancedSearchResponse.operationList[i].dtAmt;
                                    currency = operationAdvancedSearchResponse.operationList[i].dtCcy;
                                }
                                else {
                                    amount = 0;
                                    currency = operationAdvancedSearchResponse.operationList[i].amtCcy;
                                }
                            }
                        }
                        operationAdvancedSearchResponse.operationList[i].currency = currency;
                        if (amount) {
                            if (amount.toString() === "0") {
                                operationAdvancedSearchResponse.operationList[i].organizedAmount = {
                                    wholePart: "0",
                                    fractionalPart: "00"
                                }
                            }
                            else {
                                if (amount.toString().indexOf('.') !== -1) {
                                    let amountArray = amount.toString().split('.');
                                    operationAdvancedSearchResponse.operationList[i].organizedAmount = {
                                        wholePart: amountArray[0],
                                        fractionalPart: (amountArray[1].length === 1) ? (amountArray[1] + '0') : amountArray[1]
                                    }
                                }
                                else {
                                    operationAdvancedSearchResponse.operationList[i].organizedAmount = {
                                        wholePart: amount.toString(),
                                        fractionalPart: "00"
                                    }
                                }
                            }
                        } else {
                            operationAdvancedSearchResponse.operationList[i].organizedAmount = {
                                wholePart: "0",
                                fractionalPart: "00"
                            }
                        }
                    }
                    this.setState({ operations: operationAdvancedSearchResponse.operationList });
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.showStates();
        }
    }
    componentDidMount() {
        this.showStates();
    }

    render() {
        let { t } = this.props;
        let { operations } = this.state;
        return (
            <>
                {
                    operations.length === 0 ?
                        <div className="dashboard-last-operations-section-content">
                            <img src={lastOperationsIcon} className="dashboard-last-operations-section-content-image" alt="lastOperationsIcon" />
                            <p className="dashboard-last-operations-section-content-status">{t('you do not currently have any active transactions')}</p>
                            {/* <ul className="dashboard-last-operations-section-content-invisible-list">
                                <li className="dashboard-last-operations-section-content-invisible-list-item">
                                    <div className="dashboard-last-operations-section-content-invisible-list-item-circle"></div>
                                    <div className="dashboard-last-operations-section-content-invisible-list-item-content">
                                        <div className="dashboard-last-operations-section-content-invisible-list-item-content-title"></div>
                                        <div className="dashboard-last-operations-section-content-invisible-list-item-content-subtitle"></div>
                                    </div>
                                </li>
                                <li className="dashboard-last-operations-section-content-invisible-list-item">
                                    <div className="dashboard-last-operations-section-content-invisible-list-item-circle"></div>
                                    <div className="dashboard-last-operations-section-content-invisible-list-item-content">
                                        <div className="dashboard-last-operations-section-content-invisible-list-item-content-title"></div>
                                        <div className="dashboard-last-operations-section-content-invisible-list-item-content-subtitle"></div>
                                    </div>
                                </li>
                                <li className="dashboard-last-operations-section-content-invisible-list-item">
                                    <div className="dashboard-last-operations-section-content-invisible-list-item-circle"></div>
                                    <div className="dashboard-last-operations-section-content-invisible-list-item-content">
                                        <div className="dashboard-last-operations-section-content-invisible-list-item-content-title"></div>
                                        <div className="dashboard-last-operations-section-content-invisible-list-item-content-subtitle"></div>
                                    </div>
                                </li>
                            </ul> */}
                        </div>
                        :
                        <ul className="dashboard-transfer-history-content" style={{ maxHeight: '42vh', overflowY: 'auto' }}>
                            {
                                operations.map(operation => (
                                    <li className="dashboard-transfer-history-content-item" style={{ cursor: 'pointer' }} key={operation.operId} onClick={() => operation.operStateId === 7 && this.props.history.push("/dashboard/transfer/edit-pending/abroad/" + operation.operId)}>
                                        <div className="dashboard-transfer-history-content-item-container__left-side">
                                            <div className="dashboard-transfer-history-content-item-container-icon-section">
                                                <img src={operationFilter((operation.operNameId === 1 && operation.operTypeId === 15) ? 15 : operation.operNameId)} className="dashboard-transfer-history-content-item-container-icon" />
                                            </div>
                                            <div className="dashboard-transfer-history-content-item-container-content">
                                                <p className="dashboard-transfer-history-content-item-container-name">{operation.operPurpose}, {t(transferFilter(operation.operNameId) && ((operation.operNameId === 1 && operation.operTypeId === 15) ? transferFilter(15).name : transferFilter(operation.operNameId).name))}</p>
                                                <p className="dashboard-transfer-history-content-item-container-iban">{operation.crIban}</p>
                                            </div>
                                        </div>
                                        <div className="dashboard-transfer-history-content-item-container__right-side">
                                            <div className="dashboard-transfer-history-content-item-container-content">
                                                <div className="dashboard-transfer-history-content-item-container-amount">
                                                    <span className="dashboard-transfer-history-content-item-container-amount-whole">{operation.organizedAmount && operation.organizedAmount.wholePart}</span>
                                                    <span className="dashboard-transfer-history-content-item-container-amount-fractional">{operation.organizedAmount && operation.organizedAmount.fractionalPart}</span>
                                                    <span className="dashboard-transfer-history-content-item-container-amount-currency">{operation.currency}</span>
                                                </div>
                                                <p className="dashboard-transfer-history-content-item-container-type">{operation.operState}</p>
                                            </div>
                                            {
                                                operation.operStateId === 1 && <div className="dashboard-transfer-history-content-item-container-type-circle dashboard-transfer-history-content-item-container-type-circle__confirmed"></div>
                                            }
                                            {
                                                operation.operStateId === 2 && <div className="dashboard-transfer-history-content-item-container-type-circle dashboard-transfer-history-content-item-container-type-circle__waiting"></div>
                                            }
                                            {
                                                operation.operStateId === 3 && <div className="dashboard-transfer-history-content-item-container-type-circle dashboard-transfer-history-content-item-container-type-circle__first-authorization"></div>
                                            }
                                            {
                                                operation.operStateId === 4 && <div className="dashboard-transfer-history-content-item-container-type-circle dashboard-transfer-history-content-item-container-type-circle__second-authorization"></div>
                                            }
                                            {
                                                operation.operStateId === 5 && <div className="dashboard-transfer-history-content-item-container-type-circle dashboard-transfer-history-content-item-container-type-circle__refused"></div>
                                            }
                                            {
                                                operation.operStateId === 7 && <div className="dashboard-transfer-history-content-item-container-type-circle dashboard-transfer-history-content-item-container-type-circle__edit-pending"></div>
                                            }
                                        </div>
                                    </li>
                                ))
                            }
                        </ul>
                }
            </>
        )
    }
}
export default translate("translation")(Statements);

